import {
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Skeleton,
  Typography
} from '@mui/material'
import React, { Fragment } from 'react'
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined'

type SearchAutocompleteProps = {
  loading: boolean
  searchTerm: string
  onSelect: (selected: string) => void
  matchedWords: {
    term: string
    match: {
      startIndex: number
      endIndex: number
    }
  }[]
}

const SearchAutocomplete: React.FC<SearchAutocompleteProps> = ({
  loading,
  onSelect,
  matchedWords,
  searchTerm
}) => {
  if (loading) {
    return (
      <Fragment>
        {Array.from({ length: 3 }).map((_, index) => (
          <ListItem disablePadding key={`skeleton-${index}`}>
            <ListItemButton disableRipple disabled>
              <ListItemIcon sx={{ minWidth: '40px' }}>
                <Skeleton animation="wave" width="24px" height="24px" />
              </ListItemIcon>
              <ListItemText primary={<Skeleton animation="wave" height="24px" />} />
            </ListItemButton>
          </ListItem>
        ))}
      </Fragment>
    )
  }

  return (
    <Fragment>
      {!loading && matchedWords.length === 0 ? (
        <ListItem disablePadding>
          <ListItemButton disableRipple onClick={() => onSelect(searchTerm)}>
            <ListItemIcon sx={{ minWidth: '40px' }}>
              <SearchOutlinedIcon fontSize="medium" />
            </ListItemIcon>
            <ListItemText
              primary={
                <Typography variant="body1" color="grey.900">
                  {searchTerm}
                </Typography>
              }
            />
          </ListItemButton>
        </ListItem>
      ) : (
        matchedWords.map(i => (
          <ListItem disablePadding key={i.term}>
            <ListItemButton disableRipple onClick={() => onSelect(i.term)}>
              <ListItemIcon sx={{ minWidth: '40px' }}>
                <SearchOutlinedIcon fontSize="medium" />
              </ListItemIcon>
              <ListItemText
                primary={
                  <Typography variant="body1" color="grey.900">
                    {[
                      i.term.slice(0, i.match.startIndex),
                      <b key="highlighted">
                        {i.term.slice(i.match.startIndex, i.match.endIndex + 1)}
                      </b>,
                      i.term.slice(i.match.endIndex + 1)
                    ]}
                  </Typography>
                }
              />
            </ListItemButton>
          </ListItem>
        ))
      )}
    </Fragment>
  )
}

export default SearchAutocomplete
